<template>
  <div :class="`form-element form-${type}-element`">
    <FormLabel
      :required="options.required"
      :title="options.title"
      :filled="internalValue !== undefined && internalValue !== null"
      :field-type="type"
    />
    <v-row>
      <v-col>
        <v-btn
          :color="internalValue === true ? 'primary' : null"
          block
          @click="internalValue = (internalValue === true) ? null : true"
        >
          {{ trueLabel }}
        </v-btn>
      </v-col>
      <v-col>
        <v-btn
          :color="internalValue === false ? 'primary' : null"
          block
          @click="internalValue = (internalValue === false) ? null : false"
        >
          {{ falseLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FormLabel from '../FormLabel';

export default {
  components: {
    FormLabel
  },
  props: {
    value: { type: Boolean, default: null },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  computed: {
    trueLabel () {
      if (this.options.answer_pair === 'custom') {
        return this.options.custom_true;
      } else {
        return this.$t('form.elements.checkbox.answer_pairs.' + (this.options.answer_pair || 'default') + '.true');
      }
    },
    falseLabel () {
      if (this.options.answer_pair === 'custom') {
        return this.options.custom_false;
      } else {
        return this.$t('form.elements.checkbox.answer_pairs.' + (this.options.answer_pair || 'default') + '.false');
      }
    },
    internalValue: {
      get () {
        return this.value;
      },
      set (v) {
        this.$emit('input', v);
      }
    }
  }
};
</script>
